import { render, staticRenderFns } from "./enduserDeclaration.vue?vue&type=template&id=43b174c5&scoped=true"
import script from "./enduserDeclaration.vue?vue&type=script&lang=js"
export * from "./enduserDeclaration.vue?vue&type=script&lang=js"
import style0 from "./enduserDeclaration.vue?vue&type=style&index=0&id=43b174c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b174c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43b174c5')) {
      api.createRecord('43b174c5', component.options)
    } else {
      api.reload('43b174c5', component.options)
    }
    module.hot.accept("./enduserDeclaration.vue?vue&type=template&id=43b174c5&scoped=true", function () {
      api.rerender('43b174c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/enduserDeclaration/enduserDeclaration.vue"
export default component.exports